module.exports = __webpack_public_path__ + "img/delivery.7199f878.svg";